<template>
    <div>
        <div class="fisthang">
            <el-form :inline="true" class="demo-form-inline" size="mini">
                <!-- <el-form-item label="组织机构" >
                    <orgListSelect orgType="1" v-model="orgid" :on-success="onSuccess" />
                </el-form-item> -->
                <el-form-item label="日期" >
                    <el-date-picker
                        v-model="time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getData">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="reset()">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="listBox-item">
            <!-- 表格盒子 -->
            <div class="table_card">
                <el-table
                    :data="tableData"
                    :header-cell-style="{ background: '#f8fafa' }"
                    size="small"
                    border
                    align="center"
                    current-row-key
                    highlight-current-row
                >
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column align="center" prop="personName" label="用户名"></el-table-column>
                    <el-table-column align="center" prop="userPhone" label="手机号"></el-table-column>
                    <el-table-column align="center" prop="streetName" label="组织机构"></el-table-column>
                    <el-table-column align="center" prop="attendanceNum" label="应出勤(天)"></el-table-column>
                    <el-table-column align="center" prop="realAttendanceNum" label="实际出勤(天)"></el-table-column>
                    <el-table-column align="center" prop="noAttendanceNum" label="缺勤(天)"></el-table-column>
                    <el-table-column align="center" prop="lateAttendanceNum" label="迟到(天)"></el-table-column>
                    <el-table-column align="center" prop="leaveEarlyAttendanceNum" label="早退(天)"></el-table-column>
                    <el-table-column align="center" prop="leaveAttendanceNum" label="请假(天)"></el-table-column>
                    <el-table-column align="center" prop="restAttendanceNum" label="休息(天)"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import orgListSelect from "@/component/orgListSelect/index.vue";
export default {
    components: { orgListSelect },
    props: ["gridId"],
    data() {
        return {
            orgid: [],
            tableData: [],
            time: ""
        };
    },
    methods: {
        onSuccess(info) {
            // this.orgid = info.value;
            // this.getUser(info.value);
        },
        //重置日期
        reset:function(){
            this.time = ""
            this.getData()
        },
        getData() {
            this.$post(
                "admin/attendanceRecord/info/attendanceRecordStatisticsByPerson",
                {
                    gridId: this.gridId,
                    startTime: this.time[0] ? this.time[0] : "",
                    endTime: this.time[1] ? this.time[1] : ""
                }
            ).then(res => {
                console.log(res.content)
                this.tableData = res.content;
            });
        }
    },
    mounted() {
        this.getData();
    },
    created() {}
};
</script>

<style lang="less" scoped>
</style>
